<template>
    <div class="row row-style">
        <div class="col-md-6 first-col all-col-style">
            <i class="fa fa-chevron-right w20" v-if="!is_detailed" @click="$emit('toggle-details', lead.id)"></i>
            <i class="fa fa-chevron-down w20" v-else @click="$emit('untoggle-details', lead.id)"></i>

            <i class="fa fa-circle" :class="lead.status" :title="lead.decoded_status"></i>
            <div class="title-head-container">
                <h5>
                    <div v-if="displayedName.length > 0"><span>{{ displayedName }}</span></div>
                    <div v-if="displayedContactInfo.length > 0"><span>{{ displayedContactInfo }}</span></div>
                </h5>
            </div>
        </div>
        <div class="col-md-5 all-col-style">
            <ul style="margin-top: auto;margin-bottom: auto;overflow: auto;max-height: 80px;">
                <li v-if="interaction.scheduled_date && interaction.status != 'done'" v-for="(interaction, interact_idx) in interactions"
                    :key="'interactions-'+ interact_idx" style="margin-right: 15px;">
                    <i class="fa fa-wechat"></i>{{ interaction.decoded_type}} planifiée {{ interaction.scheduled_date |
                    moment-date }}
                </li>
            </ul>
        </div>
        <div class="col-md-1 all-col-style">
            <div style="margin-top:20px;">
                <router-link :to="{ name: 'lead', params: { id: lead.id } }">
                    <button class="btn ">Détails</button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from "vuex"

    export default {
        name: "LeadItem",
        props: ["lead", "idx", "is_detailed"],
        data() {
            return {}
        },
        computed: {
            ...mapState("crm", ["users"]),

            displayedName() {
                let displayedName = ''

                if (this.lead.contact_company_name)
                    displayedName += this.lead.contact_company_name

                if (this.lead.contact_first_name || this.lead.contact_last_name) {
                    if (displayedName.length > 0)
                        displayedName += ' - '

                    if (this.lead.contact_civility)
                        displayedName += `${this.lead.decoded_contact_civility} `

                    if (this.lead.contact_first_name)
                        displayedName += `${this.lead.contact_first_name} `

                    if (this.lead.contact_last_name)
                        displayedName += `${this.lead.contact_last_name} `
                }

                if (displayedName.length == 0)
                    displayedName = 'Identité non renseignée'

                return displayedName
            },

            displayedContactInfo() {
                let displayedContactInfo = ''

                if (this.lead.contact_phone)
                    displayedContactInfo += this.lead.contact_phone

                if (this.lead.contact_email) {
                    if (displayedContactInfo.length > 0)
                        displayedContactInfo += ' - '

                    displayedContactInfo += this.lead.contact_email
                }

                return displayedContactInfo
            },

            interactions() {
                return _.sortBy(this.lead.interactions, "scheduled_date")
            }
        },
        methods: {
            ...mapActions("crm", ["set_fetching_state"]),

            get_email_of(cid) {
                var found = _.find(this.users, u => {
                    return u.id === cid
                })
                return found != undefined ? found.email : null
            }
        }
    }

</script>

<style scoped>
    .ope {
        margin-bottom: 5px;
    }

    .row-style {
        min-height: 80px;
        border-bottom: solid 1px #f0f0f0;
    }

    .all-col-style {
        height: inherit;
        display: inline-flex;
        align-items: center;
    }

    .first-col {
        display: flex;
        align-items: center;
    }

    .last-col {
        display: flex;
        height: inherit;
        align-items: center;
    }

    .title-head-container {
        margin-left: 15px;
    }

    .w20 {
        width: 20px;
    }

    .fa-circle.open {
        color: #10CFBD;
    }

    .fa-circle.in_progress {
        color: #F8D053;
    }

    .fa-circle.completed {
        color: #a1733f;
    }

    .fa-circle.converted {
        color: #48B0F7;
    }

    .fa-circle.duplicate,
    .fa-circle.closed {
        color: inherit;
    }

</style>



// WEBPACK FOOTER //
// client/components/CRM/LeadItem.vue